export default __webpack_public_path__ + "static/media/fsiRealCase1.0b4478aa.jpg";